export default __webpack_public_path__ + "static/media/iot.13872ff0.mp4";